/* Refresh Cars — minimal cart + UI helpers */
(function () {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  // Minimal toast helper (non-blocking replacement for alert)
  function showToast(msg, type) {
    try {
      var t = document.createElement('div');
      t.setAttribute('role', type === 'error' ? 'alert' : 'status');
      t.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');
      t.textContent = String(msg || '');
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
        'z-index:10000;max-width:90vw;padding:12px 16px;border-radius:10px;' +
        'background:' + (type === 'error' ? '#b91c1c' : '#0a0a0a') + ';color:#fff;' +
        'font:500 14px/1.35 system-ui,sans-serif;box-shadow:0 8px 24px rgba(0,0,0,0.18);' +
        'opacity:0;transition:opacity .25s ease;';
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.style.opacity = '1'; });
      setTimeout(function () {
        t.style.opacity = '0';
        setTimeout(function () { try { t.remove(); } catch (e) {} }, 300);
      }, 4000);
    } catch (e) { if (window.console) console.warn('toast failed', e); }
  }
  window.rcToast = showToast;

  // Persistencia ligera para personalized hero + segment-aware popup
  (function trackPath(){
    var path = location.pathname;
    var mProd = path.match(/^\/products\/([^\/?#]+)/);
    var mColl = path.match(/^\/collections\/([^\/?#]+)/);
    var thirtyDays = 60 * 60 * 24 * 30;
    if (mProd) document.cookie = 'rc_last_prod=' + encodeURIComponent(mProd[1]) + '; path=/; max-age=' + thirtyDays;
    if (mColl && mColl[1] !== 'all') document.cookie = 'rc_last_cat=' + encodeURIComponent(mColl[1]) + '; path=/; max-age=' + thirtyDays;
  })();

  // Toggle mobile menu drawer
  document.addEventListener('click', (e) => {
    const menu = $('[data-mobile-menu]');
    if (e.target.closest('[data-menu-toggle]')) {
      e.preventDefault();
      menu?.classList.add('is-open');
      menu?.setAttribute('aria-hidden', 'false');
      document.body.classList.add('menu-open');
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'true');
      return;
    }
    if (e.target.closest('[data-menu-close]')) {
      menu?.classList.remove('is-open');
      menu?.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    }
  });

  // Close menu on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const menu = $('[data-mobile-menu]');
    if (menu?.classList.contains('is-open')) {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    }
  });

  // Cart drawer toggle
  let drawer = $('[data-cart-drawer]');
  document.addEventListener('click', (e) => {
    drawer = $('[data-cart-drawer]'); // re-query in case it was re-rendered
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      drawer?.classList.add('is-open');
      document.body.classList.add('drawer-open');
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
      drawer?.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
    }
  });

  // Add to cart via AJAX — INSTANTÁNEO: abre drawer + skeleton, refresca en paralelo
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[name="add"], button[type="submit"]:not([data-buy-now])');
    let originalHTML = null;
    if (btn) {
      originalHTML = btn.innerHTML;
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('disabled', 'true');
    }
    // Abre drawer INSTANTÁNEO con skeleton de carga (oculta contenido viejo)
    drawer = $('[data-cart-drawer]');
    drawer?.classList.add('is-open');
    drawer?.classList.add('is-loading');
    document.body.classList.add('drawer-open');
    try {
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!r.ok) throw new Error('add failed');
      await refreshCart();
      drawer?.classList.remove('is-loading');
      if (btn) {
        btn.innerHTML = '<span aria-hidden="true">✓</span> <span style="margin-left:6px;">Añadido</span>';
        setTimeout(() => {
          if (!btn) return;
          btn.innerHTML = originalHTML;
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('disabled');
        }, 1200);
      }
    } catch (err) {
      console.warn(err);
      drawer?.classList.remove('is-loading');
      drawer?.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      if (btn) {
        btn.innerHTML = originalHTML;
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('disabled');
      }
    }
  });

  // Buy Now: add to cart and go directly to checkout
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    e.preventDefault();
    const form = btn.closest('form[action="/cart/add"]');
    if (!form) return;
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span style="display:inline-block;width:16px;height:16px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:spin .8s linear infinite;"></span> Procesando...';
    try {
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.description || 'add failed');
      }
      // Respeta el locale/market: si el visitante está en /pt, /fr, /it…, ir al checkout localizado.
      // Sin esto, /checkout fija ES y rompe IVA/idioma para 5 markets non-ES.
      const rootBase = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/$/, '');
      window.location.href = rootBase + '/checkout';
    } catch (err) {
      console.warn('Buy now failed:', err);
      btn.disabled = false;
      btn.innerHTML = originalHTML;
      showToast('No se ha podido procesar la compra. Inténtalo de nuevo.', 'error');
    }
  });

  // Expuesta global para que handlers en main-product.liquid (bundle, sticky ATC) la reutilicen
  window.rcRefreshCart = refreshCart;
  async function refreshCart() {
    try {
      // Disparar AMBOS fetches en paralelo + Section Rendering API moderna (sections=)
      // que devuelve JSON pequeño en lugar de HTML completo (más rápido en mobile)
      const cb = Date.now();
      // Prefijo de market/idioma (Shopify.routes.root ya termina en '/'): sin él,
      // el drawer se re-renderiza desde el market primario ES (tarifa/zona/textos ES en /pt-pt, /fr-fr, etc.)
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const [cartRes, sectionRes] = await Promise.all([
        fetch('/cart.js?t=' + cb, { cache: 'no-store' }).catch(() => null),
        fetch(root + 'cart?sections=cart-drawer&t=' + cb, { cache: 'no-store' }).catch(() => null),
      ]);
      const cart = cartRes && cartRes.ok ? await cartRes.json() : null;
      if (cart) {
        $$('[data-cart-count]').forEach(el => {
          const prev = parseInt(el.textContent, 10) || 0;
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          if (cart.item_count > prev) {
            el.classList.remove('cart-count--bump');
            // eslint-disable-next-line no-void
            void el.offsetWidth;
            el.classList.add('cart-count--bump');
          }
        });
      }
      let html = null;
      if (sectionRes && sectionRes.ok) {
        try {
          const txt = await sectionRes.text();
          // Section Rendering API devuelve JSON con la key "cart-drawer"; fallback a text si no es JSON
          if (txt.trim().startsWith('{')) {
            const j = JSON.parse(txt);
            html = j['cart-drawer'] || null;
          } else {
            html = txt;
          }
        } catch (e) { html = null; }
      }
      if (typeof html === 'string' && html.length > 0) {
        try {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-drawer]');
          const current = $('[data-cart-drawer]');
          if (fresh && current) {
            const wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) current.classList.add('is-open');
            // J05 — stagger cart-line entrance after re-render
            const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!reducedMotion) {
              const lines = current.querySelectorAll('.cart-line');
              lines.forEach((ln, i) => {
                ln.style.setProperty('--i', i);
                ln.classList.add('cart-line--new');
                const cleanup = () => { ln.classList.remove('cart-line--new'); ln.style.removeProperty('--i'); ln.removeEventListener('animationend', cleanup); };
                ln.addEventListener('animationend', cleanup);
              });
            }
          }
        } catch (parseErr) { console.warn('cart-drawer parse failed', parseErr); }
      }
      // Notifica componentes que escuchan cambios de carrito (PDP ship-bar, etc.)
      try { document.dispatchEvent(new CustomEvent('rc:cart:changed', { detail: cart })); } catch (e) {}
    } catch (e) { console.warn('refreshCart', e); }
  }

  // Update cart line quantity via AJAX
  async function updateCartLine(key, quantity) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      if (!r.ok) throw new Error('change failed');
      await refreshCart();
      // If we're on the cart page, reload to update totals
      if (location.pathname.includes('/cart')) location.reload();
    } catch (e) { console.warn(e); }
  }

  // Qty steppers
  document.addEventListener('click', (e) => {
    const inc = e.target.closest('[data-qty-inc]');
    const dec = e.target.closest('[data-qty-dec]');
    if (!inc && !dec) return;
    const wrap = e.target.closest('[data-qty]');
    const input = wrap?.querySelector('input[type="number"]');
    if (!input) return;
    e.preventDefault();
    let v = parseInt(input.value, 10) || 1;
    const min = parseInt(input.min, 10);
    const minVal = isNaN(min) ? 1 : min;
    v = inc ? v + 1 : Math.max(minVal, v - 1);
    input.value = v;

    // Si el qty está en cart drawer o cart page, sincroniza con el servidor
    // (no disparamos 'change' aquí para evitar doble fetch desde el listener change)
    const cartQty = wrap.dataset.cartQty !== undefined ? wrap : null;
    if (cartQty) {
      const key = wrap.dataset.key;
      if (key) updateCartLine(key, v);
    } else {
      // Fuera de cart, disparamos change para PDP qty-breaks / sub-form listeners
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Direct typing in cart drawer qty input
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty] input[type="number"]');
    if (!input) return;
    const wrap = input.closest('[data-qty]');
    const key = wrap?.dataset.key;
    if (!key) return;
    const v = parseInt(input.value, 10) || 0;
    updateCartLine(key, v);
  });

  // Remove from cart drawer
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    const key = btn.dataset.key;
    if (!key) return;
    btn.disabled = true;
    await updateCartLine(key, 0);
  });

  // Cart page remove link (anchor)
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-remove-link]');
    if (!link) return;
    e.preventDefault();
    const url = new URL(link.href, location.origin);
    const id = url.searchParams.get('id');
    if (!id) return;
    await updateCartLine(id, 0);
  });

  // Product gallery thumbs — keep responsive srcset on switch
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const main = $('[data-product-main-image]');
    if (main) {
      const src = t.dataset.src;
      main.src = src;
      // Rebuild srcset from same image at multiple widths (Shopify CDN supports ?width=)
      const base = src.split('?')[0];
      main.srcset = `${base}?width=480 480w, ${base}?width=800 800w, ${base}?width=1200 1200w`;
    }
    $$('[data-thumb]').forEach(el => el.classList.toggle('is-active', el === t));
  });

  // TOC autogenerada en artículos largos
  const tocList = $('[data-toc-list]');
  const articleContent = $('[data-article-content]');
  if (tocList && articleContent) {
    const headings = $$('h2', articleContent);
    if (headings.length >= 3) {
      tocList.innerHTML = '';
      headings.forEach((h, i) => {
        if (!h.id) {
          h.id = 'h-' + (h.textContent || ('s' + i)).toLowerCase()
            .replace(/[áàä]/g, 'a').replace(/[éèë]/g, 'e').replace(/[íìï]/g, 'i')
            .replace(/[óòö]/g, 'o').replace(/[úùü]/g, 'u').replace(/ñ/g, 'n')
            .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 50);
        }
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        tocList.appendChild(li);
      });
    } else {
      const toc = $('[data-article-toc]');
      if (toc) toc.style.display = 'none';
    }
  }

  // Reading progress bar (artículos blog)
  // Scroll envuelto en requestAnimationFrame para evitar layout thrash en
  // artículos largos (INP friendly).
  const progressFill = $('[data-article-progress]');
  if (progressFill) {
    let ticking = false;
    const update = () => {
      const article = $('.article__body');
      if (!article) return;
      const rect = article.getBoundingClientRect();
      const total = article.offsetHeight - window.innerHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), total);
      progressFill.style.width = total > 0 ? (scrolled / total * 100) + '%' : '0%';
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // Segmentación B2C/B2B en forms de captación.
  // Si el form tiene un checkbox [data-pro-segment] marcado, añade
  // `b2b-interested` al hidden input contact[tags] antes de enviar.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-segment-form]');
    if (!form) return;
    const proCheckbox = form.querySelector('[data-pro-segment]');
    if (!proCheckbox || !proCheckbox.checked) return;
    const tagsInput = form.querySelector('input[name="contact[tags]"]');
    if (!tagsInput) return;
    const current = tagsInput.value.split(',').map(s => s.trim()).filter(Boolean);
    if (!current.includes('b2b-interested')) current.push('b2b-interested');
    tagsInput.value = current.join(',');
  }, true); // captura: corre antes que el submit nativo

  // Helpers compartidos (recently-viewed, predictive search)
  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
  function formatMoney(cents, currency) {
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  // ==========================================================
  // Recently viewed products (P2.15)
  // Guarda IDs visitados en localStorage. En PDP guarda el producto.
  // Renderiza la sección [data-recently-viewed] con un fetch por handle.
  // ==========================================================
  const RV_KEY = 'rc_recently_viewed';
  function rvList() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
  }
  function rvAdd(handle) {
    if (!handle) return;
    let list = rvList().filter(h => h !== handle);
    list.unshift(handle);
    list = list.slice(0, 12);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  // Auto-track en PDP
  const pdpHandle = document.body.dataset.productHandle || (document.querySelector('meta[property="product:retailer_part_no"]') ? null : null);
  if (window.__rcProductHandle) rvAdd(window.__rcProductHandle);
  // Render
  const rvSection = $('[data-recently-viewed]');
  if (rvSection) {
    const grid = rvSection.querySelector('[data-recently-viewed-grid]');
    const limit = parseInt(rvSection.dataset.limit, 10) || 4;
    const currentHandle = window.__rcProductHandle;
    const handles = rvList().filter(h => h !== currentHandle).slice(0, limit);
    if (handles.length && grid) {
      Promise.all(handles.map(h => fetch('/products/' + encodeURIComponent(h) + '.js').then(r => r.ok ? r.json() : null).catch(() => null)))
        .then(products => {
          const valid = products.filter(Boolean);
          if (!valid.length) return;
          grid.innerHTML = valid.map(p => {
            const img = p.featured_image ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
            return '<a class="rv-item" href="/products/' + escapeHTML(p.handle) + '">' +
              '<div class="rv-item__media">' + (img ? '<img src="' + escapeHTML(img) + '" alt="' + escapeHTML(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</div>' +
              '<div class="rv-item__info">' +
                '<div class="rv-item__title">' + escapeHTML(p.title) + '</div>' +
                '<div class="rv-item__price">' + formatMoney(p.price, 'EUR') + '</div>' +
              '</div>' +
            '</a>';
          }).join('');
          rvSection.hidden = false;
        });
    }
  }

  // ==========================================================
  // Predictive search (P2.16)
  // Abre drawer con [data-search-open], hace fetch a Shopify Predictive
  // Search API y muestra hasta 6 productos. Enter envía al listado completo.
  // ==========================================================
  const searchDrawer = $('[data-search-drawer]');
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  let searchTimer = null;
  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.hidden = false;
    document.body.style.overflow = 'hidden';
    $$('[data-search-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => searchInput && searchInput.focus(), 50);
  }
  function closeSearch() {
    if (!searchDrawer || searchDrawer.hidden) return;
    searchDrawer.hidden = true;
    document.body.style.overflow = '';
    $$('[data-search-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }
  function renderSearch(data, q) {
    if (!searchResults) return;
    const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    if (!products.length) {
      searchResults.innerHTML = '<div class="rc-search__empty">No hay resultados para "' + escapeHTML(q) + '". Prueba con otra palabra.</div>';
      return;
    }
    const items = products.slice(0, 6).map(p => {
      const img = p.image || (p.featured_image && p.featured_image.url) || '';
      return '<a class="rc-search__item" href="' + escapeHTML(p.url) + '">' +
        (img ? '<img src="' + escapeHTML(img) + '" alt="" loading="lazy">' : '<div style="width:48px;height:48px;background:#eee;border-radius:8px"></div>') +
        '<div class="rc-search__item-info">' +
          '<div class="rc-search__item-title">' + escapeHTML(p.title) + '</div>' +
          '<div class="rc-search__item-price">' + escapeHTML(p.price || '') + '</div>' +
        '</div>' +
      '</a>';
    }).join('');
    searchResults.innerHTML = '<div class="rc-search__group"><h3>Productos</h3>' + items + '</div>' +
      '<a class="rc-search__view-all" href="/search?q=' + encodeURIComponent(q) + '">Ver todos los resultados →</a>';
  }
  function debouncedSearch(q) {
    clearTimeout(searchTimer);
    if (!q || q.length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      return;
    }
    searchTimer = setTimeout(() => {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(r => r.json())
        .then(data => renderSearch(data, q))
        .catch(() => {});
    }, 200);
  }
  if (searchInput) searchInput.addEventListener('input', (e) => debouncedSearch(e.target.value.trim()));
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-search-close]')) { closeSearch(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchDrawer && !searchDrawer.hidden) closeSearch();
    if (e.key === '/' && document.activeElement && !['INPUT','TEXTAREA','SELECT'].includes(document.activeElement.tagName)) {
      e.preventDefault();
      openSearch();
    }
  });

  // ==========================================================
  // Cookie consent reopen link y collection sort (P2.20)
  // Migra los onclick="" inline a delegación para CSP-readiness.
  // ==========================================================
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-open-consent]');
    if (!link) return;
    e.preventDefault();
    // El consentimiento lo gestiona el banner NATIVO de Shopify (Privacy API);
    // rcOpenConsent era del banner custom que nunca se renderiza.
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.openBanner === 'function') {
      window.Shopify.customerPrivacy.openBanner();
    } else if (typeof window.rcOpenConsent === 'function') {
      window.rcOpenConsent();
    }
  });
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-auto-submit]');
    if (sel && sel.form) sel.form.submit();
  });
  document.addEventListener('click', (e) => {
    const tog = e.target.closest('[data-toggle-target]');
    if (!tog) return;
    e.preventDefault();
    const sel = tog.getAttribute('data-toggle-target');
    const target = sel && document.querySelector(sel);
    if (target) target.style.display = target.style.display === 'none' ? 'block' : 'none';
  });

  // Initial cart count fetch — deferred to idle to not compete with LCP
  const fetchCart = () => fetch('/cart.js').then(r => r.json()).then(cart => {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
  }).catch(() => {});
  if ('requestIdleCallback' in window) requestIdleCallback(fetchCart, { timeout: 2000 });
  else setTimeout(fetchCart, 1500);

  // Cleanup timers/listeners on unload to avoid leaks in long sessions / bfcache
  window.addEventListener('beforeunload', () => {
    try { if (searchTimer) clearTimeout(searchTimer); } catch (e) {}
  }, { once: true });

  // ==========================================================
  // J01 — IntersectionObserver: scroll-reveal para .fade-up / .fade-up-stagger
  // ==========================================================
  (function fadeUpObserver(){
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      $$('.fade-up, .fade-up-stagger').forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      $$('.fade-up, .fade-up-stagger').forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.classList.contains('fade-up-stagger')) {
          Array.from(el.children).forEach(function(child, i){ child.style.setProperty('--i', i); });
        }
        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    $$('.fade-up, .fade-up-stagger').forEach(function(el){ io.observe(el); });
    // Re-observe dinámicos (cart drawer, ajax). Expone helper:
    window.rcObserveFadeUp = function(scope){
      var ctx = scope || document;
      ctx.querySelectorAll('.fade-up, .fade-up-stagger').forEach(function(el){
        if (!el.classList.contains('is-visible')) io.observe(el);
      });
    };
  })();

  // ==========================================================
  // J02 — Header sticky: activa el blur translúcido solo al hacer scroll
  // (perf: backdrop-filter recompone cada frame; lo evitamos en el tope).
  // ==========================================================
  (function headerScrolled(){
    var header = document.querySelector('.site-header');
    if (!header) return;
    var ticking = false;
    var apply = function(){
      header.classList.toggle('is-scrolled', window.pageYOffset > 8);
      ticking = false;
    };
    window.addEventListener('scroll', function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }, { passive: true });
    apply();
  })();

  // ==========================================================
  // J08 — Per-field validation en .form-field (aria-invalid en blur, clear en input)
  // ==========================================================
  (function fieldValidation(){
    function validate(el){
      if (!el.willValidate) return true;
      var ok = el.checkValidity();
      el.setAttribute('aria-invalid', ok ? 'false' : 'true');
      // Mensaje inline opcional
      var wrap = el.closest('.form-field, .pro-form__field');
      if (wrap) {
        var errEl = wrap.querySelector('.form-field__error');
        if (!ok) {
          if (!errEl) {
            errEl = document.createElement('span');
            errEl.className = 'form-field__error';
            wrap.appendChild(errEl);
          }
          errEl.textContent = el.validationMessage || 'Campo inválido';
        } else if (errEl) {
          errEl.remove();
        }
      }
      return ok;
    }
    document.addEventListener('blur', function(e){
      var el = e.target;
      if (!el || !el.matches) return;
      if (!el.matches('.form-field input, .form-field select, .form-field textarea, .pro-form__field input, .pro-form__field select, .pro-form__field textarea')) return;
      validate(el);
    }, true);
    document.addEventListener('input', function(e){
      var el = e.target;
      if (!el || !el.matches) return;
      if (!el.matches('.form-field input, .form-field textarea, .pro-form__field input, .pro-form__field textarea')) return;
      if (el.getAttribute('aria-invalid') === 'true') validate(el);
    });
  })();

  // ==========================================================
  // J09 — Loading state genérico en forms con .form-submit-loading
  // ==========================================================
  (function formSubmitLoading(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('form-submit-loading')) return;
      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (!btn) return;
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('disabled', 'true');
    });
    window.addEventListener('pageshow', function(){
      $$('.form-submit-loading button[aria-busy="true"], .form-submit-loading input[aria-busy="true"]').forEach(function(btn){
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('disabled');
      });
    });
  })();

  // ==========================================================
  // J10 — Hold-press en qty buttons (mousedown 400ms → repetir cada 80ms)
  // ==========================================================
  (function qtyHoldPress(){
    var holdTimer = null;
    var repeatTimer = null;
    function stop(){
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      if (repeatTimer) { clearInterval(repeatTimer); repeatTimer = null; }
    }
    document.addEventListener('mousedown', function(e){
      var btn = e.target.closest('[data-qty-inc], [data-qty-dec]');
      if (!btn) return;
      var wrap = btn.closest('[data-qty]');
      var input = wrap && wrap.querySelector('input[type="number"]');
      if (!input) return;
      var isInc = btn.matches('[data-qty-inc]');
      var min = parseInt(input.min, 10);
      var minVal = isNaN(min) ? 1 : min;
      holdTimer = setTimeout(function(){
        repeatTimer = setInterval(function(){
          var v = parseInt(input.value, 10) || 1;
          v = isInc ? v + 1 : Math.max(minVal, v - 1);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, 80);
      }, 400);
    });
    document.addEventListener('mouseup', stop);
    document.addEventListener('mouseleave', stop, true);
    document.addEventListener('touchend', stop);
    document.addEventListener('touchcancel', stop);
  })();
})();
